import { useMemo } from 'react'
import { useStores } from 'stores/utils/hooks/useStores'
import { isTenantSmava } from 'utils/url'
import { isRceEditConfig } from 'config/utils/config'
import { RCE_EDIT_PAGE_NAMES } from 'utils/pages'

interface LayoutFlags {
  isDacFooterWrapperStep: boolean
  isProgressIndicatorDisplayed: boolean
  areDDFTrustCardsDisplayed: boolean
  isAgbShownAtBottomOfPage: boolean
  isDacFooterWrapperDisplayed: boolean
  isSmava: boolean
  isRCEEditPage: boolean
}

export const useLayoutFlags = (
  currentPageInSession?: string,
  configName?: string
): LayoutFlags => {
  const { navigation } = useStores()

  const isSmava = isTenantSmava()

  return useMemo(() => {
    const isRCEEditPage = configName ? isRceEditConfig(configName) : false

    const isDacFooterWrapperStep = currentPageInSession === 'dac'

    const isProgressIndicatorDisplayed =
      !isDacFooterWrapperStep &&
      !isRCEEditPage &&
      !RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

    const areDDFTrustCardsDisplayed =
      isSmava &&
      currentPageInSession !== 'dac' &&
      !RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

    const isAgbShownAtBottomOfPage = currentPageInSession === 'editPage'

    const isDacFooterWrapperDisplayed =
      isDacFooterWrapperStep &&
      !isRCEEditPage &&
      navigation.currentPageInSession !== 'loadingLead'

    return {
      isDacFooterWrapperStep,
      isProgressIndicatorDisplayed,
      areDDFTrustCardsDisplayed,
      isAgbShownAtBottomOfPage,
      isDacFooterWrapperDisplayed,
      isSmava,
      isRCEEditPage
    }
  }, [
    currentPageInSession,
    configName,
    navigation.currentPageInSession,
    isSmava
  ])
}
